// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const GridBlock = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 100 60" {...props}>
    <path
      stroke="currentColor"
      fill="none"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M14.3 7.3H35V28H14.3zM39.7 7.3h20.7V28H39.7zM65 7.3h20.7V28H65zM14.3 32H35v20.7H14.3zM39.7 32h20.7v20.7H39.7zM65 32h20.7v20.7H65z"
    />
  </svg>
);

export default GridBlock;
